<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      订单管理
      <small>
        /&nbsp;
        <router-link to="/orderreview" class="TitleStyle">订单审核</router-link>/&nbsp;订单详情
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">订单详情</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <span class="TInfo">基本信息</span>
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">
                       <li class="TableContent">
                        <span class="TCode">订单状态：</span>
                        <span class="TCodeContent">{{OrderList.orderstatus}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">订单编号：</span>
                        <span class="TCodeContent">{{OrderList.orderNo}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">所属机构：</span>
                        <span class="TCodeContent">{{OrderList.deptName ? OrderList.lesseeName + ' - ' + OrderList.deptName : OrderList.lesseeName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">大区：</span>
                        <span class="TCodeContent">{{OrderList.firstAreaName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">分区：</span>
                        <span class="TCodeContent">{{OrderList.secondAreaName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">区域：</span>
                        <span class="TCodeContent">{{OrderList.thirdAreaName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">所属分销商：</span>
                        <span class="TCodeContent">{{OrderList.recomName}}</span>
                      </li>
                       <li class="TableContent">
                        <span class="TCode">订购人：</span>
                        <span class="TCodeContent">{{OrderList.buyerName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">联系方式：</span>
                        <span class="TCodeContent">{{OrderList.buyerTel}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">身份证号：</span>
                        <span class="TCodeContent">{{OrderList.buyerIdcard}}</span>
                      </li>
                    <!--  <li class="TableContent">
                        <span class="TCode">订单ID号：</span>
                        <span class="TCodeContent">{{OrderList.orderId}}</span>
                      </li>




                      <li class="TableContent">
                        <span class="TCode">下单时间：</span>
                        <span class="TCodeContent">{{OrderList.buyerTime}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">支付状态：</span>
                        <span class="TCodeContent">{{OrderList.paystatus}}</span>
                      </li>


                       <li class="TableContent">
                        <span class="TCode">提现状态：</span>
                        <span class="TCodeContent">{{OrderList.}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">提现时间：</span>
                        <span class="TCodeContent">{{OrderList.}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">商品数量：</span>
                        <span class="TCodeContent">{{OrderList.goodsCount}}</span>
                      </li>

                      <li class="TableContent">
                        <span class="TCode">订单税款：</span>
                        <span class="TCodeContent">{{OrderList.teaxes}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">运费：</span>
                        <span class="TCodeContent">{{OrderList.expresses}}</span>
                      </li>
                     -->

                      <li class="clear"></li>
                    </ul>
                  </div>
                  <div class="GTitle">
                    <span class="TInfo">支付信息</span>
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">
                      <li class="TableContent">
                        <span class="TCode">订单总金额：</span>
                        <span class="TCodeContent">{{ OrderList.orderPrice +  OrderList.orderDiscount }}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">实际支付金额：</span>
                        <span class="TCodeContent">{{ OrderList.orderPrice }}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">总税款：</span>
                        <span class="TCodeContent">{{ ((OrderList.orderPrice +  OrderList.orderDiscount) / 1.091 * 0.091 || 0).toFixed(2) }}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">总货款：</span>
                        <span class="TCodeContent">{{
                            (OrderList.orderPrice +  OrderList.orderDiscount - OrderList.expresses) / 1.091 > 0 ?
                              ((OrderList.orderPrice +  OrderList.orderDiscount - OrderList.expresses) / 1.091).toFixed(2) : 0
                          }}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">运费：</span>
                        <span class="TCodeContent">{{ OrderList.expresses }}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">优惠金额：</span>
                        <span class="TCodeContent">{{ OrderList.orderDiscount || 0 }}
                          <el-tooltip placement="top" v-if="OrderList.discountJson && (JSON.parse(OrderList.discountJson || '{}').randomDiscount ||
                           JSON.parse(OrderList.discountJson || '{}').goodsReduceDiscount || JSON.parse(OrderList.discountJson || '{}').orderBigReduceDiscount)">
                            <div slot="content">
                               <p v-if="JSON.parse(OrderList.discountJson || '{}').randomDiscount">
                               随机立减：{{Number(JSON.parse(OrderList.discountJson || '{}').randomDiscount).toFixed(2)}}
                             </p>
                             <p v-if="JSON.parse(OrderList.discountJson || '{}').goodsReduceDiscount">
                               订单立减：{{Number(JSON.parse(OrderList.discountJson || '{}').goodsReduceDiscount).toFixed(2)}}
                             </p>
                              <p v-if="JSON.parse(OrderList.discountJson || '{}').orderBigReduceDiscount">
                                大额立减：{{Number(JSON.parse(OrderList.discountJson || '{}').orderBigReduceDiscount).toFixed(2)}}
                              </p>
                            </div>
                            <i class="el-icon-question"></i>
                          </el-tooltip>
                          </span>
                      </li>

                      <li class="TableContent">
                        <span class="TCode">支付流水号：</span>
                        <span class="TCodeContent">{{OrderList.payVoucher}}</span>
                      </li>
                        <li class="TableContent">
                        <span class="TCode">支付公司：</span>
                        <span class="TCodeContent">{{OrderList.paytype}}</span>
                      </li>
                        <li class="TableContent">
                        <span class="TCode">支付时间：</span>
                        <span class="TCodeContent">{{OrderList.payTime}}</span>
                      </li>


                      <li class="clear"></li>
                    </ul>
                  </div>


                  <div class="GTitle">
                    <span class="TInfo">收货人信息</span>
                  </div>

                  <div class="GContent">
                    <ul class="GContentUl">

                      <li class="TableContent">
                        <span class="TCode">收货人：</span>
                        <span class="TCodeContent">{{OrderList.resUser}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">联系方式：</span>
                        <span class="TCodeContent">{{OrderList.resTel}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">身份证号：</span>
                        <span class="TCodeContent">{{OrderList.resIdcard}}</span>
                      </li>
                       <li class="TableContent">
                        <span class="TCode">省：</span>
                        <span class="TCodeContent">{{OrderList.resProvince}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">市：</span>
                        <span class="TCodeContent">{{OrderList.resCity}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">区：</span>
                        <span class="TCodeContent">{{OrderList.resDistrict}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">收件人详细地址：</span>
                        <span class="TCodeContent">{{OrderList.resAddress}}</span>
                      </li>

                        <li class="TableContent">
                        <span class="TCode">发货时间：</span>
                        <span class="TCodeContent"></span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">物流公司：</span>
                        <span class="TCodeContent"></span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">快递单号：</span>
                        <span class="TCodeContent">{{OrderList.bagNo}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">发货状态：</span>
                        <span class="TCodeContent"></span>
                      </li>

                      <li class="clear"></li>
                    </ul>
                  </div>
                  <div class="GTitle" >
                    <span class="TInfo">订单商品信息</span>
                  </div>
                  <div class="GContent">
                    <el-table :data="tableData" border style="width: 100%">
                       <el-table-column prop="orderNo" label="订单编号" align="center"></el-table-column>
                      <el-table-column prop="brandName" label="品牌名称" align="center"></el-table-column>
                      <el-table-column prop="seriesName" label="系列名称" width="180" align="center"></el-table-column>

                      <el-table-column prop="goodsName" label="商品名称" width="180" show-overflow-tooltip header-align="center"></el-table-column>
                      <el-table-column prop="" label="平台料号" width="180" align="center"></el-table-column>
                      <el-table-column prop="totalCount" label="数量" width="180" align="center"></el-table-column>
                      <el-table-column prop="sellingPrice" label="单价" width="180" align="center"></el-table-column>
                      <el-table-column label="总货款" align="center">
                        <template slot-scope="scope">
                          {{(scope.row.payment  / 1.091).toFixed(2)}}
                        </template>
                      </el-table-column>
                      <el-table-column label="总税款" width="180" align="center">
                        <template slot-scope="scope">
                          {{(scope.row.payment - scope.row.payment  / 1.091).toFixed(2)}}
                        </template>
                      </el-table-column>
                      <el-table-column prop="discountAmount" label="优惠金额" align="center"></el-table-column>
                    </el-table>
                  </div>
                  <div class="GTitle">
                    <span class="TInfo">订单赠品信息</span>
                  </div>
                  <div class="GContent">
                    <el-table :data="giftList" border style="width: 100%">
                      <el-table-column prop="orderNo" label="订单编号" align="center"></el-table-column>
                      <el-table-column prop="giftActivityGoodsName" label="赠品商品名称" align="center"></el-table-column>
                      <el-table-column prop="giftActivityGoodsCode" label="赠品商品编码" align="center"></el-table-column>
                      <el-table-column prop="giftCount" label="赠品商品数量" width="180"
                                       align="center"></el-table-column>
                    </el-table>
                  </div>

                  <div style="height:46px;padding-top:16px;">
                    <a
                      class="btn btn-primary m-r-5"
                      style="float:right;cursor:pointer;color:#fff !important"
                      @click="Goback"
                    >返&nbsp;&nbsp;回</a>

                    <span class="clear"></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- end panel -->
          </div>

          <!-- end col-10 -->
        </div>

        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "OrderDetail",
  data() {
    return {
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      OrderList:[],
      activities:[],
      searchContent:{},
      giftList: []
    };
  },
  mounted: function() {
     this.initdata()
  },
  methods: {
    Goback() {
      this.$router.push({ name: "OrderReview" , params: { pageNo : this.pageNo , pagesize:this.pageSize,searchContent: this.searchContent}});
    },
    initdata() {

      let that = this;
       if(localStorage.getItem('goodlist')){
       let goodlist =localStorage.getItem('goodlist');

        this.pageNo = JSON.parse(goodlist).pageNo;
        this.pageSize = JSON.parse(goodlist).pageSize;
        this.searchContent =JSON.parse(goodlist).searchContent
    }
     const initoptions = {
        url: "distribution/B2cOrderInfoController/queryDetailsOrders",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: JSON.parse(localStorage.getItem('goodlist')).row.recomId,
          orderNo: JSON.parse(localStorage.getItem('goodlist')).row.orderNo,
        })
      };
      axios(initoptions)
        .then(function(response) {

          if (response.data.code == 200) {

           switch (response.data.data.orderStatus) {
            case 0:
              response.data.data.orderstatus = "取消订单";
              break;
          case 1:
              response.data.data.orderstatus = "购物车";
              break;
          case 2:
              response.data.data.orderstatus = "已提交，未支付";
              break;
          case 3:
             response.data.data.orderstatus = "已支付";
              break;
          case 4:
              response.data.data.orderstatus = "拦截";
              break;
          case 5:
               response.data.data.orderstatus = "审核放行，流转到中台";
              break;
          case 6:
             response.data.data.orderstatus = "已发货";
             break;
          case 7:
             response.data.data.orderstatus = "已收货";
             break;
          case 8:
             response.data.data.orderstatus = "交易成功";
             break;
          case 9:
             response.data.data.orderstatus = "售后";
             break;
          case 10:
             response.data.data.orderstatus = "退货";
             break;
          case 11:
             response.data.data.orderstatus = "退款";
             break;
          case 12:
             response.data.data.orderstatus = "换货";
             break;
           case 13:
             response.data.data.orderstatus = "交易关闭";
           }
           switch (response.data.data.payStatus) {
            case 0:
              response.data.data.paystatus = "未支付";
              break;
          case 3:
             response.data.data.paystatus = "支付凭证已支付";
              break;
          case 4:
              response.data.data.paystatus = "电子支付已支付";

           }
           switch (response.data.data.payType) {
            case 1:
              response.data.data.paytype = "支付宝";
              break;
            case 2:
              response.data.data.paytype = "盛付通";
              break;
          case 3:
             response.data.data.paytype = "微信";
              break;
          case 4:
              response.data.data.paytype = "汇付支付";

           }
           that.OrderList = response.data.data;
          that.tableData = response.data.data.goosInfos;
            if (that.OrderList.orderId) {
              that.getOrderGift(that.OrderList.orderId)
            }
          } else {
              http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });

    },
    getOrderGift(orderId) {
      let that = this;
      const options = {
        url: "distribution/b2cGiftOrder/queryGiftOrderByOrderId",
        method: "GET",
        params: {
          orderId: orderId
        }
      };
      axios(options)
        .then((response) => {
          if (response.data.code == 200) {
            that.giftList = response.data.data;
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function (error) {
          http.handleHttpError(error, that);
        });
    }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}
@media screen and (min-width:1360px) and (max-width:1680px){ /*二栏布局*/ .TableContent{width: 50%;}  }
@media screen and (min-width:1680px) and (max-width:2000px){ /*二栏布局*/ .TableContent{width: calc(100%/3);}  }
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
}
.TCode {
  color: #999999;
  text-align: left;
  display: inline-block;
  width: 150px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 150px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top: 8px;
  padding-bottom: 8px;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}
.tableAll,
.tableOne,
.tableSku {
  font-size: 14px;
  margin-bottom: 0;
}
.tableAll > tbody > tr > td {
  border: none;
  width: 25%;
  padding: 5px 15px;
}
.tableAll > tbody > tr {
  text-align: left;
}
.TCode {
  color: #999999;
  text-align: left;
  display: inline-block;

}
.tableOne {
  border: 1px #e5e5e5 solid;
}
.tbheader {
  background: #f4f4f4;
  text-align: left;
}
.tbone {
  border: 1px #e5e5e5 solid;
}
.trbottom > td {
  border-bottom: none;
}
.tdprice {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderManage/OrderReviewDetail.vue